import { ShareVideoButton } from 'client/components/Sharing/ShareVideoButton';

export const ArchivesShareModal = (props: { procedureId: number }) => {
    return <ShareVideoButton procedureId={props.procedureId}></ShareVideoButton>;
};
